export const Icons = ({ className = '', variant, onClick = () => {} }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.FOLDER: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.5625 8.125V6.71875C16.5625 5.9421 15.9329 5.3125 15.1562 5.3125H10.2344C10.0868 5.3125 9.9479 5.24303 9.85937 5.125L9.01562 4C8.75005 3.6459 8.33325 3.4375 7.89062 3.4375H3.90625C3.1296 3.4375 2.5 4.0671 2.5 4.84375V14.2188C2.5 14.9954 3.1296 15.625 3.90625 15.625H14.7053C15.264 15.625 15.7697 15.2943 15.9936 14.7824L18.3317 9.43827C18.6027 8.81887 18.1489 8.125 17.4728 8.125H6.21226C5.66375 8.125 5.1653 8.44393 4.93545 8.94195L2.5 14.2188"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        );
      }
      case Icons.DESCRIPTION: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <path d="M10 12H22" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
            <path d="M10 16H22" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
            <path d="M10 20H17" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      }
      case Icons.EMAIL: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <rect
              x="8"
              y="10"
              width="16"
              height="12"
              rx="2"
              stroke="#747475"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M8 11L15.4 16.55C15.7556 16.8167 16.2444 16.8167 16.6 16.55L24 11"
              stroke="#747475"
              strokeWidth="2"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.LINKS: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <path
              d="M12.4651 15.2931C13.5981 14.1601 15.5741 14.1601 16.7071 15.2931L17.4141 16.0001L18.8281 14.5861L18.1211 13.8791C17.1781 12.9351 15.9221 12.4141 14.5861 12.4141C13.2501 12.4141 11.9941 12.9351 11.0511 13.8791L8.92905 16.0001C7.99384 16.939 7.46875 18.2103 7.46875 19.5356C7.46875 20.8608 7.99384 22.1321 8.92905 23.0711C9.39283 23.5357 9.9439 23.9041 10.5506 24.155C11.1572 24.4059 11.8075 24.5344 12.4641 24.5331C13.1207 24.5345 13.7712 24.4061 14.3781 24.1552C14.9849 23.9043 15.5362 23.5359 16.0001 23.0711L16.7071 22.3641L15.2931 20.9501L14.5861 21.6571C14.0225 22.2181 13.2597 22.533 12.4646 22.533C11.6694 22.533 10.9066 22.2181 10.3431 21.6571C9.78156 21.0938 9.46626 20.3309 9.46626 19.5356C9.46626 18.7402 9.78156 17.9773 10.3431 17.4141L12.4651 15.2931Z"
              fill="#747475"
            />
            <path
              d="M15.9999 8.9307L15.2929 9.6377L16.7069 11.0517L17.4139 10.3447C17.9774 9.78369 18.7402 9.46873 19.5354 9.46873C20.3305 9.46873 21.0933 9.78369 21.6569 10.3447C22.2184 10.908 22.5337 11.6709 22.5337 12.4662C22.5337 13.2615 22.2184 14.0244 21.6569 14.5877L19.5349 16.7087C18.4019 17.8417 16.4259 17.8417 15.2929 16.7087L14.5859 16.0017L13.1719 17.4157L13.8789 18.1227C14.8219 19.0667 16.0779 19.5877 17.4139 19.5877C18.7499 19.5877 20.0059 19.0667 20.9489 18.1227L23.0709 16.0017C24.0061 15.0627 24.5312 13.7915 24.5312 12.4662C24.5312 11.1409 24.0061 9.86968 23.0709 8.9307C22.1324 7.99451 20.861 7.46875 19.5354 7.46875C18.2098 7.46875 16.9383 7.99451 15.9999 8.9307Z"
              fill="#747475"
            />
          </svg>
        );
      }
      case Icons.FILES: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <path
              d="M17.7998 7.89844V11.4984C17.7998 11.7371 17.8946 11.9661 18.0634 12.1348C18.2322 12.3036 18.4611 12.3984 18.6998 12.3984H22.2998"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.5002 24.0984H11.5002C11.0228 24.0984 10.565 23.9088 10.2274 23.5712C9.88984 23.2337 9.7002 22.7758 9.7002 22.2984V9.69844C9.7002 9.22105 9.88984 8.76321 10.2274 8.42565C10.565 8.08808 11.0228 7.89844 11.5002 7.89844H17.8002L22.3002 12.3984V22.2984C22.3002 22.7758 22.1106 23.2337 21.773 23.5712C21.4354 23.9088 20.9776 24.0984 20.5002 24.0984Z"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path d="M13.5 15.5H18.5" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
            <path d="M13.5 19.5H16.5" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      }
      case Icons.TAGS: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <path d="M14.5 9L11 23" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
            <path d="M21 9L17.5 23" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
            <path d="M9.5 13H23.5" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
            <path d="M8.5 19H22.5" stroke="#747475" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      }
      case Icons.LINK_OUT: {
        return (
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.99">
              <path
                d="M6.5 3H5C3.89543 3 3 3.89543 3 5V11C3 12.1046 3.89543 13 5 13H11C12.1046 13 13 12.1046 13 11V9.5"
                stroke="#2B59DA"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 3H13V6"
                stroke="#2B59DA"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.5 3.5L8 8"
                stroke="#2B59DA"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        );
      }
      case Icons.CHECKLIST: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <g clipPath="url(#clip0_81832_97189)">
              <path
                d="M13.4993 10.168H11.8327C11.3907 10.168 10.9667 10.3436 10.6542 10.6561C10.3416 10.9687 10.166 11.3926 10.166 11.8346V21.8346C10.166 22.2767 10.3416 22.7006 10.6542 23.0131C10.9667 23.3257 11.3907 23.5013 11.8327 23.5013H20.166C20.608 23.5013 21.032 23.3257 21.3445 23.0131C21.6571 22.7006 21.8327 22.2767 21.8327 21.8346V11.8346C21.8327 11.3926 21.6571 10.9687 21.3445 10.6561C21.032 10.3436 20.608 10.168 20.166 10.168H18.4993"
                stroke="#747475"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.8333 8.5H15.1667C14.2462 8.5 13.5 9.24619 13.5 10.1667C13.5 11.0871 14.2462 11.8333 15.1667 11.8333H16.8333C17.7538 11.8333 18.5 11.0871 18.5 10.1667C18.5 9.24619 17.7538 8.5 16.8333 8.5Z"
                stroke="#747475"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.5 17.6667L15.1667 19.3333L18.5 16"
                stroke="#747475"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_81832_97189">
                <rect width="20" height="20" fill="white" transform="translate(6 6)" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.CLAUSE: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <path
              d="M12.7528 22.2403C17.0379 25.9425 23.1453 20.4999 16.1562 18.5088C9.45435 16.5995 11.7434 13.6332 14.7497 13.0833"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M19.2472 9.75991C14.9621 6.05722 8.85467 11.5001 15.8438 13.4915C22.5457 15.401 20.2566 18.3667 17.2503 18.9167"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        );
      }
      case Icons.PUBLISHED_TO_TEAM: {
        return (
          <svg
            width="33"
            height="33"
            viewBox="0 0 33 33"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <path
              d="M19.0888 12.8833C19.0888 14.5889 17.7061 15.9716 16.0005 15.9716C14.2948 15.9716 12.9121 14.5889 12.9121 12.8833C12.9121 11.1776 14.2948 9.79492 16.0005 9.79492C17.7061 9.79492 19.0888 11.1776 19.0888 12.8833Z"
              stroke="#747475"
              strokeWidth="2"
            />
            <path
              d="M11.3672 21.893C11.6559 20.2432 12.9833 18.8047 14.4554 18.8047H17.5439C19.016 18.8047 20.3435 20.2432 20.6322 21.893"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M21.3213 11.8555C22.5376 12.0595 23.4644 13.1174 23.4644 14.3917C23.4644 15.666 22.5376 16.7238 21.3213 16.9279"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M22.1777 19.3203C23.4036 19.3203 24.5091 20.5182 24.7495 21.8921"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.6787 11.8555C9.46239 12.0595 8.53558 13.1174 8.53558 14.3917C8.53558 15.666 9.46239 16.7238 10.6787 16.9279"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M9.82129 19.3203C8.59538 19.3203 7.48996 20.5182 7.24954 21.8921"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="25" cy="25" r="7" fill="#04A451" stroke="white" strokeWidth="2" />
            <path
              d="M22.5 25.5L24 27.5L27.5 23"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.TIMELINE: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <g clipPath="url(#clip0_81832_129350)">
              <path
                d="M15.167 11H22.667"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.167 16H22.667"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.167 21H22.667"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="10.5833" cy="10.9993" r="1.08333" stroke="#515151" strokeWidth="2" />
              <circle cx="10.5833" cy="15.9993" r="1.08333" stroke="#515151" strokeWidth="2" />
              <circle cx="10.5833" cy="20.9993" r="1.08333" stroke="#515151" strokeWidth="2" />
            </g>
            <defs>
              <clipPath id="clip0_81832_129350">
                <rect width="20" height="20" fill="white" transform="translate(6 6)" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.EMAIL_TEMPLATES: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <rect
              x="8"
              y="10"
              width="16"
              height="12"
              rx="2"
              stroke="#515151"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M8 11L15.4 16.55C15.7556 16.8167 16.2444 16.8167 16.6 16.55L24 11"
              stroke="#515151"
              strokeWidth="2"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.ARROW_UP: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" fill="white" />
            <path
              d="M11.5 18L16 13.5L20.5 18"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.ARROW_DOWN: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="32" height="32" rx="16" transform="matrix(1 0 0 -1 0 32)" fill="white" />
            <path
              d="M11.5 14L16 18.5L20.5 14"
              stroke="#747475"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.EMPTY_PROJECTS: {
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_81832_129539)">
              <path
                d="M25.667 14H46.667"
                stroke="#D6D6D7"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25.667 28H46.667"
                stroke="#D6D6D7"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25.667 42H46.667"
                stroke="#D6D6D7"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="12.8333" cy="13.9993" r="4.08333" stroke="#D6D6D7" strokeWidth="3.5" />
              <circle cx="12.8333" cy="27.9993" r="4.08333" stroke="#D6D6D7" strokeWidth="3.5" />
              <circle cx="12.8333" cy="41.9993" r="4.08333" stroke="#D6D6D7" strokeWidth="3.5" />
            </g>
            <defs>
              <clipPath id="clip0_81832_129539">
                <rect width="56" height="56" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.TASK: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="16" cy="16" r="16" fill="#D6D6D7" fillOpacity="0.25" />
            <g clipPath="url(#clip0_80671_211906)">
              <path
                d="M8.91602 10.5833L10.166 11.8333L12.2493 9.75"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.91602 15.5833L10.166 16.8333L12.2493 14.75"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.91602 20.5833L10.166 21.8333L12.2493 19.75"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.166 11H22.666"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.166 16H22.666"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.166 21H22.666"
                stroke="#515151"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_80671_211906">
                <rect width="20" height="20" fill="white" transform="translate(6 6)" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      case Icons.EMPTY_TASK: {
        return (
          <svg
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_81808_82676)">
              <path
                d="M8.16602 12.8333L11.666 16.3333L17.4994 10.5"
                stroke="#AAABAB"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.16602 26.8333L11.666 30.3333L17.4994 24.5"
                stroke="#AAABAB"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.16602 40.8333L11.666 44.3333L17.4994 38.5"
                stroke="#AAABAB"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25.666 14H46.666"
                stroke="#AAABAB"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25.666 28H46.666"
                stroke="#AAABAB"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M25.666 42H46.666"
                stroke="#AAABAB"
                strokeWidth="3.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_81808_82676">
                <rect width="56" height="56" fill="white" />
              </clipPath>
            </defs>
          </svg>
        );
      }
      default:
        return null;
    }
  };
  return (
    <div style={{ display: 'flex' }} onClick={onClick} className={className}>
      {renderIcon()}
    </div>
  );
};

Icons.FOLDER = 'folder';
Icons.DESCRIPTION = 'description';
Icons.EMAIL = 'email';
Icons.LINKS = 'links';
Icons.FILES = 'files';
Icons.TAGS = 'tags';
Icons.LINK_OUT = 'link_out';
Icons.CHECKLIST = 'checklist';
Icons.CLAUSE = 'clause';
Icons.PUBLISHED_TO_TEAM = 'publishedTeam';
Icons.TIMELINE = 'timeline';
Icons.EMAIL_TEMPLATES = 'emailTemp';
Icons.ARROW_UP = 'arrowUp';
Icons.ARROW_DOWN = 'arrowDown';
Icons.EMPTY_PROJECTS = 'emptyProjects';
Icons.EMPTY_TASK = 'emptyTasks';
Icons.TASK = 'task';
